module.exports = __webpack_public_path__ + "static/media/julia.5a1011ea.webp";